// Correos extra que reciben el PDF de cada análisis en segundo plano de la
// empresa (el usuario que lanza el análisis siempre lo recibe).
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Box, Typography, TextField, Button, Stack, Chip } from '@mui/material';
import { Save } from '@mui/icons-material';
import { API_BASE_URL_SECURITY } from '../../../../utils/config';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const CompanyReportEmails = ({ empresa, securityConfig, onSaved }) => {
    const [correos, setCorreos] = useState([]);
    const [nuevo, setNuevo] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        setCorreos(Array.isArray(empresa?.correosReportesAnalisis) ? empresa.correosReportesAnalisis : []);
    }, [empresa?._id, empresa?.correosReportesAnalisis]);

    const agregar = () => {
        const correo = nuevo.trim().toLowerCase();
        if (!correo) return;
        if (!EMAIL_RE.test(correo)) {
            toast.error('Escribe un correo válido.');
            return;
        }
        if (!correos.includes(correo)) setCorreos([...correos, correo]);
        setNuevo('');
    };

    const guardar = async () => {
        setGuardando(true);
        try {
            await axios.put(
                `${API_BASE_URL_SECURITY}empresas/${empresa._id}/correos-reportes`,
                { correos },
                securityConfig()
            );
            toast.success('Correos de reportes guardados.');
            if (typeof onSaved === 'function') await onSaved();
        } catch (error) {
            toast.error(error.response?.data?.message || 'No fue posible guardar los correos.');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Box sx={{ mt: 2, p: 2, borderRadius: 2, bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
            <Typography variant="subtitle2" fontWeight={700}>
                Correos que reciben los reportes PDF
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
                Al terminar un análisis en segundo plano, el PDF se envía al usuario que lo lanzó y a estos correos.
            </Typography>
            <Stack direction="row" gap={1} flexWrap="wrap" sx={{ my: 1.5 }}>
                {correos.length === 0 && (
                    <Typography variant="caption" color="text.secondary">Sin correos extra.</Typography>
                )}
                {correos.map((correo) => (
                    <Chip
                        key={correo}
                        label={correo}
                        size="small"
                        onDelete={() => setCorreos(correos.filter((c) => c !== correo))}
                    />
                ))}
            </Stack>
            <Stack direction="row" gap={1} alignItems="center">
                <TextField
                    size="small"
                    label="Agregar correo"
                    value={nuevo}
                    onChange={(e) => setNuevo(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            agregar();
                        }
                    }}
                    sx={{ flex: 1 }}
                />
                <Button size="small" variant="outlined" onClick={agregar}>Agregar</Button>
                <Button
                    size="small"
                    variant="contained"
                    startIcon={<Save />}
                    onClick={guardar}
                    disabled={guardando}
                    sx={{
                            backgroundColor: '#111827',
                            color: '#fff',
                            fontWeight: 700,
                            '&:hover': { backgroundColor: '#000', color: '#fff' },
                            '&.Mui-disabled': { backgroundColor: '#6b7280', color: '#f3f4f6' },
                        }}
                >
                    Guardar
                </Button>
            </Stack>
        </Box>
    );
};

export default CompanyReportEmails;
